import request from '@/utils/request'

export function epms6020(param) {
    let data = param
    return request({
        url: `/supplier/epms6020/epms6020`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function epms6020Detail(param) {
    let data = param
    return request({
        url: `/supplier/epms6020/epms6020Detail`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}